import { useState } from "react";
import { toast } from "sonner";
import { useApiService } from "../../services/apiService";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import {
  collectionPath,
  colors,

  type Collection,
  type CollectionDetail,
} from "./collections";
import { CollectionColorPicker } from "./CollectionColorPicker";
import "./collections.css";
export function CollectionEditor({
  collection,
  onSaved,
  onClose,
}: {
  collection?: Collection;
  onSaved: (value: CollectionDetail) => void;
  onClose: () => void;
}) {
  const api = useApiService();
  const [name, setName] = useState(collection?.name ?? "");
  const [description, setDescription] = useState(collection?.description ?? "");
  const [color, setColor] = useState(
    collection ? collection.colorLabel : colors[0]
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open && !saving) onClose();
      }}
    >
      <DialogContent className="collection-editor-dialog">
        <DialogHeader>
          <DialogTitle>
            {collection ? "Edit collection" : "Create collection"}
          </DialogTitle>
          <DialogDescription>
            Collections are shared with your native app.
          </DialogDescription>
        </DialogHeader>
        <form
          className="collection-form"
          onSubmit={async (event) => {
            event.preventDefault();
            if (!name.trim() || saving) return;
            setSaving(true);
            setError("");
            try {
              const body = { name: name.trim(), colorLabel: color, description: description.trim() || null };
              const saved = collection
                ? await api.patch<CollectionDetail>(
                    `${collectionPath}/${collection.id}/changes`,
                    { details: body, addedProductEntityIds: [], removedProductEntityIds: [] }
                  )
                : await api.post<CollectionDetail>(collectionPath, body);
              toast.success("Collection saved");
              onSaved(saved);
            } catch {
              setError("Could not save the collection. Please try again.");
            } finally {
              setSaving(false);
            }
          }}
        >
          <label>
            Name
            <input
              autoFocus
              required
              maxLength={200}
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={saving}
            />
          </label>
          <label>
            Description
            <input maxLength={2000} value={description} onChange={event => setDescription(event.target.value)} disabled={saving} placeholder="Add a description" />
          </label>
          <CollectionColorPicker value={color} disabled={saving} onChange={setColor} />
          {error && <p role="alert">{error}</p>}
          <div className="collection-actions">
            <Button
              type="button"
              variant="outline"
              disabled={saving}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button disabled={saving || !name.trim()}>
              {saving ? "Saving…" : "Save collection"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

